
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/en'
import 'dayjs/locale/ja'
import 'dayjs/locale/zh'
import 'dayjs/locale/ru'
import 'dayjs/locale/ko'
import 'dayjs/locale/de'
import 'dayjs/locale/es'
import 'dayjs/locale/pt'
import 'dayjs/locale/id'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import 'dayjs/locale/tr'
import 'dayjs/locale/pl'
import 'dayjs/locale/uk'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'


dayjs.extend(updateLocale)

dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)

dayjs.tz.setDefault('America/New_York')

// defaultLocale: "en"


dayjs.updateLocale("en")
dayjs.locale('en')


export default dayjs
